import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=f013edfa&scoped=true"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013edfa",
  null
  
)

export default component.exports